export default "__VITE_ASSET__CGKnkqpQ__";